module.exports = __webpack_public_path__ + "static/media/jaison.e829d41c.jpg";